/**
 * Industry Types Enumeration
 * Defines the supported industry verticals in the POS system
 */
export enum IndustryType {
    /** Retail industry - Standard POS operations */
    RETAIL = 4,

    /** Mobile industry - Mobile phone sales with mapping, variants, and free quantity features */
    MOBILE = 14,

    /** Restaurant industry - Category-grid UI with image product tiles and bill panel */
    RESTAURANT = 7,

    /** Pharmacy industry - Drug/medicine sales with batch & expiry tracking */
    PHARMACY = 15,
}

/**
 * Helper function to check if an industry type is valid
 */
export function isValidIndustry(industry: number | string): boolean {
     const id = industry != null ? Number(industry) : null;
     return id != null && !isNaN(id) && Object.values(IndustryType).includes(id);
}

/**
 * Get industry name from industry code
 */
export function getIndustryName(industry: number | string): string {
    const id = industry != null ? Number(industry) : null;

    switch (id) {
        case IndustryType.RETAIL:
            return 'Retail';
        case IndustryType.MOBILE:
            return 'Mobile';
        case IndustryType.RESTAURANT:
            return 'Restaurant';
        case IndustryType.PHARMACY:
            return 'Pharmacy';
        default:
            return 'Unknown';
    }
}
